module.exports = __webpack_public_path__ + "static/3-873657590d3fbfa61aea1b7674a76f74.jpg";